import React from "react";
import GenericTable from "../../GenericTable";

/* ---------------------------- Destinations Table ---------------------------- */
export const Destinations = () => {
  const visibleColumns = [
    { key: "destination_type", label: "Type" },
    { key: "destination_prefix", label: "Prefix" },
    { key: "destination_number", label: "Destination" },
    { key: "action", label: "Actions" },
    { key: "destination_context", label: "Context" },
    { key: "destination_enabled", label: "Enabled" },
    { key: "destination_description", label: "Description" },
  ];

  return (
    <GenericTable
      tableName="v_destinations"
      title="Destinations"
      parentName="HUCS"
      addRoute="/admin/hucs/add/destinations"
      editBaseRoute="/admin/hucs/edit"
      rowKey="destination_uuid"
      visibleColumns={visibleColumns}
    />
  );
};
